import { getSiteDataUsage } from '@wix/ambassador-cloud-data-usage-v1-site-data-usage/http'
import type { SiteDataUsage } from '@wix/ambassador-cloud-data-usage-v1-site-data-usage/types'
import type { HttpClient } from '@wix/http-client'

export const formatPremiumLimits = ({
  collectionCountLimit,
  itemCountLimit,
}: SiteDataUsage) => {
  return {
    collectionCountLimit: collectionCountLimit ? collectionCountLimit : 0,
    itemCountLimit: itemCountLimit ? Number(itemCountLimit) : 0,
  }
}

export const getPremiumLimits = async (httpClient: HttpClient) => {
  const fields = ['collectionCountLimit', 'itemCountLimit']

  const {
    data: { siteDataUsage },
  } = await httpClient.request(getSiteDataUsage({ fields }))

  return siteDataUsage ? formatPremiumLimits(siteDataUsage) : undefined
}
